<template lang="pug">
.workshop-survey
  div.header
    h1.workshop-survey-title déclarer un atelier Declick
    img.logo(src="../../assets/img/logoColombbus.png")
  form.workshop-survey-form
    .workshop-survey-tip
      | Tous les champs sont requis sauf mention contraire.
    .workshop-survey-row
      .workshop-survey-label-box
        label.workshop-survey-label(for='workshop-survey-input--animator-code')
          | Quel est votre code animateur ?
      .workshop-survey-input-box
        input(
          v-model.trim='fields.animatorCode'
          type='text'
          placeholder='code animateur'
          id='workshop-survey-input--animator-code'
        )
        .workshop-survey-error(v-if='fieldsErrors.animatorCodeError')
          | {{ fieldsErrors.animatorCodeError }}
      .workshop-survey-row
        .workshop-survey-label-box
          label.workshop-survey-label
            | Sur quel type d'activité ?
        .workshop-survey-input-box
          area-picker(
            v-model='fields.type'
            :options="[{label: 'TAP', value: 'TAP'}, {label: 'collège', value: 'collège'}]"
          )
          .workshop-survey-error(v-if='fieldsErrors.typeError')
            | {{ fieldsErrors.typeError }}
      .workshop-survey-row
        .workshop-survey-label-box
          label.workshop-survey-label(for='workshop-survey-input--establishment')
            | Dans quel établissement êtes-vous intervenu ?
        .workshop-survey-input-box
          selection-list(
            v-model='fields.establishment'
            :options="fields.type === 'TAP' ? allTapEstablishments : allHighSchoolEstablishments"
            placeholder='établissement'
            required
            id='workshop-survey-input--establishment'
          )
          .workshop-survey-error(v-if='fieldsErrors.establishmentError')
            | {{ fieldsErrors.establishmentError }}

      template(v-if="fields.type === 'TAP'")
        .workshop-survey-row
          .workshop-survey-label-box
            label.workshop-survey-label
              | Sur quel créneau horaire ?
          .workshop-survey-input-box
            area-picker(
              v-model='fields.tapDay'
              :options='allDays'
              name='workshop-survey-input--day'
            )
            .workshop-survey-error(v-if='fieldsErrors.tapDayError')
              | {{ fieldsErrors.tapDayError }}
        .workshop-survey-row(v-if='fields.tapDay')
          .workshop-survey-label-box
            label.workshop-survey-label Quel jour ?
          .workshop-survey-input-box
            weekday-selector(
              v-model='fields.tapDate'
              :day='fields.tapDay'
            )
            .workshop-survey-error(v-if='fieldsErrors.tapDateError')
              | {{ fieldsErrors.tapDateError }}

      template(v-if="fields.type === 'collège'")
        .workshop-survey-row
          .workshop-survey-label-box
            label.workshop-survey-label De quelle heure ?
          .workshop-survey-input-box
            datetime(
              v-model='fields.highSchoolFromTime'
              type='datetime'
              value-zone='Europe/Paris'
              zone='Europe/Paris'
              :format="{ year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit' }"
              :phrases="{ok: 'valider', cancel: 'annuler'}"
              :minute-step="5"
            )
            .workshop-survey-error(v-if='fieldsErrors.highSchoolFromTimeError')
              | {{ fieldsErrors.highSchoolFromTimeError }}
        .workshop-survey-row
          .workshop-survey-label-box
            label.workshop-survey-label Jusqu'à quelle heure ?
          .workshop-survey-input-box
            datetime(
              v-model='fields.highSchoolToTime'
              type='datetime'
              value-zone='Europe/Paris'
              zone='Europe/Paris'
              :format="{ year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit' }"
              :phrases="{ok: 'valider', cancel: 'annuler'}"
              :minute-step="5"
            )
            .workshop-survey-error(v-if='fieldsErrors.highSchoolToTimeError')
              | {{ fieldsErrors.highSchoolToTimeError }}

      .workshop-survey-row
        .workshop-survey-label-box
          label.workshop-survey-label(
            for='workshop-survey-input--participant-count'
          ) Combien y a-t-il eu de participants ?
        .workshop-survey-input-box
          input(
            v-model.number='fields.participantCount'
            type='number'
            placeholder='nombre de participants'
            id='workshop-survey-input--participant-count'
          )
          .workshop-survey-error(v-if='fieldsErrors.participantCountError')
            | {{ fieldsErrors.participantCountError }}
      .workshop-survey-row
        .workshop-survey-label-box
          label.workshop-survey-label(for='workshop-survey-input--activitiesDetails')
            | Quelles activités les participants ont-ils fait ?
        .workshop-survey-input-box
          textarea(
            v-model.trim='fields.activitiesDetails'
            placeholder='détails des activités'
            required
            id='workshop-survey-input--activitiesDetails'
          )
          .workshop-survey-error(v-if='fieldsErrors.activitiesDetailsError')
            | {{ fieldsErrors.activitiesDetailsError }}
      .workshop-survey-row
        .workshop-survey-label-box
          label.workshop-survey-label(
            for='workshop-survey-input--appreciation-level'
          ) Comment évalueriez-vous l'appréciation des participants ?
        .workshop-survey-input-box
          selection-list(
            v-model='fields.appreciationRating'
            :options='allAppreciationRatings'
            placeholder='appréciation'
            required
            id='workshop-survey-input--appreciation-level'
          )
          .workshop-survey-error(v-if='fieldsErrors.appreciationRatingError')
            | {{ fieldsErrors.appreciationRatingError }}
      .workshop-survey-row(v-if="fields.appreciationRating === 'mauvaise'")
        .workshop-survey-label-box
          label.workshop-survey-label(
            for='workshop-survey-input--appreciation-details'
          ) Pour quelles raisons ?
        .workshop-survey-input-box
          textarea(
            v-model.trim='fields.appreciationDetails'
            placeholder="détails de l'appréciation"
            required
            id='workshop-survey-input--appreciation-details'
          )
          .workshop-survey-error(v-if='fieldsErrors.appreciationDetailsError')
            | {{ fieldsErrors.appreciationDetailsError }}
      .workshop-survey-row
        .workshop-survey-label-box
          label.workshop-survey-label(for='workshop-survey-input--has-met-bugs')
            | Avez-vous rencontré des dysfonctionnements avec les outils
            | utilisés ?
        .workshop-survey-input-box
          selection-list(
            v-model='fields.hadBugs'
            :options='allHadBugsOptions'
            placeholder='dysfonctionnements'
            required
            id='workshop-survey-input--has-met-bugs'
          )
          .workshop-survey-error(v-if='fieldsErrors.hadBugsError')
            | {{ fieldsErrors.hadBugsError }}
      .workshop-survey-row(v-if="fields.hadBugs === 'oui'")
        .workshop-survey-label-box
          label.workshop-survey-label(for='workshop-survey-input--bug-details')
            | Lesquels ?
        .workshop-survey-input-box
          textarea(
            v-model.trim='fields.bugsDetails'
            placeholder='détails des dysfonctionnements'
            required
            id='workshop-survey-input--bug-details'
          )
          .workshop-survey-error(v-if='fieldsErrors.bugsDetailsError')
            | {{ fieldsErrors.bugsDetailsError }}
      .workshop-survey-row
        .workshop-survey-label-box
          label.workshop-survey-label(for='workshop-survey-input--remarks')
            | Avez-vous d'autres remarques à faire ?
            span.workshop-survey-tip &nbsp;(optionnel)
        .workshop-survey-input-box
          textarea(
            v-model.trim='fields.remarks'
            placeholder='remarques'
            id='workshop-survey-input--remarks'
          )
          .workshop-survey-error(v-if='fieldsErrors.remarksError')
            | {{ fieldsErrors.remarksError }}
    .workshop-survey-row
      .workshop-survey-submit-box
        button.workshop-survey-submit-button(
          @click='submit'
          v-if="status === 'inactive'"
          type='button'
        )
          span
          | &#128232;&nbsp;envoyer 
        button.workshop-survey-submit-button(
          v-if="status === 'pending'"
          type='button'
          disabled
        )
          span.workshop-survey-waiting-icon
          | &nbsp;envoi en cours
        button.workshop-survey-submit-button(
          v-if="status === 'done'"
          type='button'
          disabled
        )
          span.workshop-survey-done-icon
          | &nbsp;envoi effectué, merci
        .workshop-survey-error(v-if='globalError')
          | {{ globalError }}
  div(class="mesRaportLink")
    router-link(to="/mesRapports" ) mes rapports
</template>

<script>
import axios from 'axios'
import { Settings } from 'luxon'
import moment from 'moment'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import AreaPicker from '@/components/generic/input/AreaPicker'
import SelectionList from '@/components/generic/input/SelectionList'
import WeekdaySelector from '@/components/generic/input/WeekdaySelector'
import * as fieldsOptions from '@/components/workshop/fields-options'

export const MISSING_REQUIRED_FIELD = 'Ce champ est requis.'
export const INVALID_VALUES =
  "Envoi annulé, le formulaire n'est pas correctement rempli."
export const WRONG_CODE = 'Envoi annulé, le code animateur est incorrect.'

Settings.defaultLocale = 'fr'

export default {
  data() {
    return {
      allTapEstablishments:[],
      allHighSchoolEstablishments:[],
      testDatetime: null,
      fields: {
        animatorCode: '',
        type: 'TAP',
        establishment: null,
        highSchoolFromTime: null,
        highSchoolToTime: null,
        tapDay: null,
        tapDate: null,
        participantCount: null,
        activitiesDetails: '',
        appreciationRating: null,
        appreciationDetails: '',
        hadBugs: null,
        bugsDetails: '',
        remarks: '',
      },
      fieldsErrors: {
        animatorCodeError: null,
        typeError: null,
        establishmentError: null,
        highSchoolFromTimeError: null,
        highSchoolToTimeError: null,
        tapDayError: null,
        tapDateError: null,
        participantCountError: null,
        activitiesDetailsError: null,
        appreciationRatingError: null,
        appreciationDetailsError: null,
        hadBugsError: null,
        bugsDetailsError: null,
        remarksError: null,
      },
      globalError: null,
      status: 'inactive',
    }
  },
  computed: {
    requiredFields() {
      const fields = [
        'animatorCode',
        'establishment',
        'participantCount',
        'activitiesDetails',
        'appreciationRating',
        'hadBugs',
      ]
      if (this.fields.appreciationRating === 'mauvaise') {
        fields.push('appreciationDetails')
      }
      if (this.fields.hadBugs === 'oui') {
        fields.push('bugsDetails')
      }
      if (this.fields.type === 'TAP') {
        fields.push('tapDay')
        fields.push('tapDate')
      } else if (this.fields.type === 'collège') {
        fields.push('highSchoolFromTime')
        fields.push('highSchoolToTime')
      }
      return fields
    },
    // allTapEstablishments: () => fieldsOptions.allTapEstablishments,
    // allHighSchoolEstablishments: () =>
      // fieldsOptions.allHighSchoolEstablishments,
    allDays: () => fieldsOptions.allDays,
    allAppreciationRatings: () => fieldsOptions.allAppreciationRatings,
    allHadBugsOptions: () => fieldsOptions.allHadBugsOptions,
    computedType: function() {
      return this.fields.type
    },
  },
  watch: {
    computedType(from, to) {
      if (from !== to) {
        this.fields.establishment = null
      }
    },
    fields: {
      handler() {
        for (const field in this.fields) {
          if (this.requiredFields.includes(field)) {
            if (!this.isFieldEmpty(field)) {
              this.clearFieldError(field)
            }
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getSchoolsList()
  },
  methods: {
    async getSchoolsList() {
      await axios.get(`${process.env.VUE_APP_BACK_END_PATH}/allEstablishments`).then(r => {
        for(let establishment in r.data){
          if(r.data[establishment].schools){
            this.allTapEstablishments.push(r.data[establishment].schools)
          } else{
            this.allHighSchoolEstablishments.push(r.data[establishment].colleges)
          }
        }
      })
    },
    isFieldEmpty(field) {
      const value = this.fields[field]
      return value === undefined || value === null || value.length === 0
    },
    setFieldError(field, error) {
      this.fieldsErrors[`${field}Error`] = error
    },
    fieldHasError(field) {
      return this.fieldsErrors[`${field}Error`] === null
    },
    clearFieldError(field) {
      this.fieldsErrors[`${field}Error`] = null
    },
    async submit() {
      let isReady = true
      for (const field of this.requiredFields) {
        if (this.isFieldEmpty(field)) {
          this.setFieldError(field, MISSING_REQUIRED_FIELD)
          isReady = false
        }
      }
      if (!isReady) {
        this.globalError = INVALID_VALUES
        return
      }

      let fromTime, toTime

      if (this.fields.type === 'TAP') {
        const date = moment(this.fields.tapDate, 'DD MMM YYYY', 'fr')
        fromTime = date
          .clone()
          .hours(15)
          .format('YYYY-MM-DD HH:mm:ss')
        toTime = date
          .clone()
          .hours(16)
          .minutes(30)
          .format('YYYY-MM-DD HH:mm:ss')
      } else if (this.fields.type === 'collège') {
        fromTime = moment(this.fields.highSchoolFromTime)
          .seconds(0)
          .format('YYYY-MM-DD HH:mm:ss')
        toTime = moment(this.fields.highSchoolToTime)
          .seconds(0)
          .format('YYYY-MM-DD HH:mm:ss')
      }

      const data = { ...this.fields, fromTime, toTime }
      delete data.tapDay
      delete data.tapDate
      delete data.highSchoolFromTime
      delete data.highSchoolToTime

      this.globalError = null
      this.status = 'pending'

      try {
        let BACK_END_PATH = process.env.VUE_APP_BACK_END_PATH

        await axios.post(`${BACK_END_PATH}/reports`, data)
        this.status = 'done'
      } catch (exception) {
        this.globalError = WRONG_CODE
        this.status = 'inactive'
      }
    },
  },
  components: {
    AreaPicker,
    Datetime,
    SelectionList,
    WeekdaySelector,
  },
}
</script>

<style >
.header{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 15px;
  margin-bottom: 50px;
  border-bottom: 1px solid black;
}
.mesRaportLink {
  text-align: right;
}
</style>